import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import * as S from "./style";
import { UrlInternal } from "common/constants/endpoints";

type dataMenu = {
  title: string;
  url: string;
};
interface Props {
  data: dataMenu[];
  isShowMultipleLang?: boolean;
}

function TabHeader({ data, isShowMultipleLang }: Props) {
  const [active, setActive] = useState(data[0].url);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [hasScroll, setHasScroll] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useMemo(() => setActive(location?.pathname), [location?.pathname]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkScroll = () => {
      setHasScroll(el.scrollWidth > el.clientWidth);
    };

    // 초기 체크
    checkScroll();

    // 리사이즈 시 다시 체크
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [data]);

  return (
    <S.Wrapper className="wrapper-menu">
      <S.Container ref={containerRef} isCentered={!hasScroll}>
        {data.map((item, index) => (
          <S.Tab
            key={index}
            onClick={() => {
              setActive(item.url);
              if (
                window.location.pathname.includes(
                  UrlInternal.PATHNAME_GROUP_SALE
                ) ||
                window.location.pathname.includes(UrlInternal.PATHNAME_MYPAGE)
              ) {
                window.location.href = item.url;
              } else {
                history.push(item.url);
              }
            }}
            active={
              active === item.url || location?.pathname?.includes(item.url)
            }
          >
            {isShowMultipleLang ? item.title : t(item.title)}
          </S.Tab>
        ))}
      </S.Container>
    </S.Wrapper>
  );
}

export default TabHeader;
